import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import AuthService from "../services/Auth/AuthService";

const VerifyOtp = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const otp = searchParams.get("otp");
  const [message, setMessage] = useState("Verifying OTP...");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      if (!email || !otp) {
        setMessage("⚠️ Invalid request. Missing OTP or Email.");
        setLoading(false);
        return;
      }

      try {
        const response = await AuthService.verifyOTP(email, otp);
        console.log(response);
        if (response && response.data.statusCode === 200) {
          setMessage("✅ OTP Verified Successfully!");
          navigate("/login", {
            state: { message: "OTP Verified Successfully! Please login." },
          });
        } else if (response && response.data.statusCode === 400) {
          setMessage(
            "❌ OTP verification failed. Please check the OTP and try again."
          );
        } else {
          setMessage("❌ Unexpected error occurred.");
        }
      } catch (error) {
        if (error.response && error.response.data) {
          setMessage(
            `❌ Error: ${
              error.response.data.message || "Something went wrong!"
            }`
          );
        } else {
          setMessage("❌ An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [email, otp, navigate]);

  return <div>{loading ? <h2>Verifying OTP...</h2> : <h2>{message}</h2>}</div>;
};

export default VerifyOtp;
